var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"TInfoWhatIsLifferyNew"},[_c('m-header-seo',[_c('o-for-people-hero-section',{attrs:{"id":"hero-section"},on:{"scroll-next":_vm.handleScrollNext}})],1),_c('o-why-are-why-doing-this'),_c('o-how-people-use-liffery'),_c('o-our-mission')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }